module.exports = __webpack_public_path__ + "img/mp-flows-options.7b5ba220.jpg";